module.exports = __webpack_public_path__ + "static/media/p5.63429a79.png";